import { ActionType, ICalendarStateAction } from '../../classes/calendar-actions';

import * as moment from 'moment';
import { IPromoCodeState, defaultPromoCodeState, PromoCodeState, IPromoCodeDetail } from '../../classes/promo-code';
import { ICalendarSettings } from '../../classes/calendar';

/**
 * Returns the new search state given a particular action. This where all of the application
 * logic resides.
 */
export default function promoCodeReducer(state: IPromoCodeState = defaultPromoCodeState, action: ICalendarStateAction) {
    switch (action.type) {
        case ActionType.UpdateSettings: {
            if (action.value.promoCode != null) {
                return {
                    ...state, promoCodeState: PromoCodeState.APPLIED,
                    appliedPromoCode: (action.value.promoCode as IPromoCodeDetail).promoCode
                };
            }
            return { ...state };
        }
        case ActionType.RequestPromoCodeApply: {
            return { ...state, promoCodeRequesting: true } as IPromoCodeState;
        }
        case ActionType.ReceivePromoCodeApply: {
            return { ...state, promoCodeRequesting: false, promoCodeState: PromoCodeState.APPLIED, promoApiResponse: action.value.apiResponse, appliedPromoCode: action.value.promoCode, promoCodeError: null } as IPromoCodeState;
        }
        case ActionType.ErrorPromoCodeApply: {
            return { ...state, promoCodeRequesting: false, promoCodeState: PromoCodeState.FAILURE, promoApiResponse: action.value.apiResponse.response.data, appliedPromoCode: null, promoCodeError: action.value.apiResponse.response.data.exceptionMessage } as IPromoCodeState;
        }
        case ActionType.RequestPromoCodeRemove: {
            return { ...state, promoCodeRequesting: true } as IPromoCodeState;
        }
        case ActionType.ReceivePromoCodeRemove: {
            return { ...state, promoCodeRequesting: false, promoCodeState: PromoCodeState.ATTEMPT, promoApiResponse: action.value.apiResponse, appliedPromoCode: null, promoCodeError: null } as IPromoCodeState;
        }
        case ActionType.ErrorPromoCodeRemove: {
            return { ...state, promoCodeRequesting: false, promoCodeState: PromoCodeState.APPLIED, promoApiResponse: action.value.apiResponse, promoCodeError: action.value.apiResponse.response.data } as IPromoCodeState;
        }
        case ActionType.UpdatePromoCode: {
            return { ...state, promoCodeString: action.value } as IPromoCodeState;
        }
        case ActionType.ShowPromo: {
            return { ...state, showPromo: action.value } as IPromoCodeState;
        }
        case ActionType.ReceivePromoCodeGet: {
            return { ...state, showPromo: true, promoCodeState: PromoCodeState.APPLIED, appliedPromoCode: (action.value.apiResponse as IPromoCodeDetail).promoCode } as IPromoCodeState;
        }
        default:
            return state;
    }
}
